import { ContractButtonLink } from "@/components/Buttons/index";
import FormatWatchPrice from "@/components/FormatWatchPrice";
import { useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import styles from "@/styles/Video.module.scss";
import Image from "next/legacy/image";
import Link from "next/link";

export default function CourseInfo({ withLink, course, isLoggedIn }) {
  const discountPrice = course.discount_price;
  const discountFlag = discountPrice > 0;

  const { data: { deviceInfo } = {} } = useDeviceInfoQuery({
    fetchPolicy: "cache-first",
  });

  return (
    <div className={styles.course}>
      <div className={styles.courseInner}>
        <div className={styles.image}>
          {course?.thumbnailUrl && (
            <Image
              src={course.thumbnailUrl}
              alt={course.name}
              width={320}
              height={180}
              layout="responsive"
            />
          )}
        </div>
        <div className={styles.info}>
          <h4 className={styles.name}>{course.name}</h4>
          <div className={styles.price}>
            <FormatWatchPrice
              price={course.price}
              type="svod"
              isLoggedIn={isLoggedIn}
              discountPrice={discountPrice}
              discountFlag={discountFlag}
              course={course}
            />
          </div>
          <div className={styles.description}>{course.description}</div>
          {withLink && (
            <div className={`${styles.courseRegistBtn} ${styles.isDesktop}`}>
              <ContractButtonLink
                course={course}
                className={styles.isDesktop}
                fontFixed
              />
            </div>
          )}
        </div>
      </div>
      {withLink && (
        <div className={`${styles.courseRegistBtn} ${styles.isNotDesktop}`}>
          <ContractButtonLink course={course} fontFixed />
        </div>
      )}
      <div className={styles.condition}>
        {deviceInfo?.isAndroid && (
          <span>
            ※Android端末をご利用の方はブラウザ上ではご視聴できませんので、必ず
            <Link href={config.appStoreUrl.android}>SPOOXアプリ</Link>
            をダウンロードしてご視聴ください。
          </span>
        )}
      </div>
    </div>
  );
}
